export const notesSectionInitValue = {
  data: {
    notes: [],
    notesTotal: 0,
    page: 1,
    rowsPerPage: 10,
    isAdmin: false,
    isReadOnly: false,
    isLoadingNotes: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleAddNote: () => {},
    handleEditNote: () => {},
    handleDeleteNote: () => {},
  },
};
